import { useEffect, useState } from 'react'

import { navigate, useLocation } from '@redwoodjs/router'

export const usePageSize = (
  defaultPageSize = 10
): [number, (value: number) => void] => {
  const { search } = useLocation()

  const parsePageSize = (params: URLSearchParams) => {
    const parsed = parseInt(params.get('pageSize'), 10)
    return parsed > 0 ? parsed : defaultPageSize
  }

  const [pageSize, setPageSizeState] = useState(() =>
    parsePageSize(new URLSearchParams(search))
  )

  const setPageSize = (newValue: number) => {
    const sanitizedValue = newValue > 0 ? newValue : defaultPageSize
    if (pageSize !== sanitizedValue) {
      const params = new URLSearchParams(window.location.search)
      params.set('pageSize', sanitizedValue.toString())
      navigate(`?${params.toString()}`)
      setPageSizeState(sanitizedValue)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(search)
    const newPageSize = parsePageSize(params)
    // Only update state if the parsed page size is different from current
    if (newPageSize !== pageSize) {
      setPageSizeState(newPageSize)
    }
  }, [search, defaultPageSize])

  return [pageSize, setPageSize]
}

export default usePageSize
